<template>
  <div v-bind:class="{ 'flight-modal': true, show: flightInfo.show }" @click="close">
    <div class="flight-modal-container">
      <div class="flight-modal-content">
        <div v-if="flightInfo.loading" class="loader" @click.stop>
          <i class="fas fa-circle-notch fa-spin fa-2x"></i>
          <div class="title">Loading flight information...</div>
        </div>
        <div v-else class="flight-info" @click.stop>
          <div class="title">FLIGHT INFORMATION</div>
          <div class="label-value">
            <div class="label">AIRLINE</div>
            <div class="value">{{ flightInfo.airline.name }} ({{ flightInfo.airline.code }})</div>
          </div>
          <div class="label-value">
            <div class="label">FLIGHT NUMBER</div>
            <div class="value">{{ flightInfo.flightNumber }}</div>
          </div>
          <div class="label-value">
            <div class="label">DEPARTURE AIRPORT</div>
            <div class="value">
              <span v-if="flightInfo.departure.airportCode !== ''">
                {{ flightInfo.departure.airportCode }} - {{ flightInfo.departure.airportName }}
              </span>
              <span v-else>N/A</span>
            </div>
          </div>
          <div class="label-value" v-if="flightInfo.type === 'departure'">
            <div class="label">DEPARTURE TIME</div>
            <div class="value">
              <span v-if="flightInfo.arrival.time !== ''">{{ flightInfo.arrival.time }}</span>
              <span v-else>N/A</span></div>
          </div>
          <div class="label-value">
            <div class="label">ARRIVAL AIRPORT</div>
            <div class="value">
              <span v-if="flightInfo.arrival.airportCode !== ''">
                {{ flightInfo.arrival.airportCode }} - {{ flightInfo.arrival.airportName }}
              </span>
              <span v-else>N/A</span>
            </div>
          </div>
          <div class="label-value" v-if="flightInfo.type !== 'departure'">
            <div class="label">ARRIVAL TIME</div>
            <div class="value">
              <span v-if="flightInfo.arrival.time !== ''">{{ flightInfo.arrival.time }}</span>
              <span v-else>N/A</span></div>
          </div>
          <div class="label-value">
            <div class="label">STATUS</div>
            <div class="value">{{ flightInfo.status }}</div>
          </div>
          <div class="close-button">
            <a class="button block small" @click="close">CLOSE</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'flight-information-modal',
  computed: {
    flightInfo () {
      return this.$store.state.flightInformation
    }
  },
  methods: {
    close () {
      this.$store.commit('flightInformation/hide')
    }
  }
}
</script>

<style lang="scss" scoped>
.flight-modal {
  position: fixed;
  z-index: 999;
  top: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
  display: table;
  opacity: 0;
  transition: all 250ms;

  &.show{
    top: 0;
    opacity: 1;
  }
}

.flight-modal-container {
  display: table-cell;
  vertical-align: middle;
}

.flight-modal-content {
  text-align: center;
  overflow: hidden;
}

.loader {
  padding: 15px;
  background-color: #fff;
  border-radius: 3px;
  max-width: 300px;
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.35);

  & i {
    display: block;
    color: #0D79F2;
  }
  & .title {
    margin-top: 10px;
    color: #777;
    font-weight: 700;
  }
}

.flight-info {
  background-color: #fff;
  border-radius: 3px;
  max-width: 300px;
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.35);

  & .title {
    background-color: #333;
    color: #fff;
    font-weight: 700;
    padding: 5px;
  }
  & .label-value {
    padding: 10px 0;
    margin: 0 15px;

    border-bottom: 1px solid rgba(0,0,0,0.15);

    & .label {
      font-size: 10px;
      font-weight: 700;
      color: #777;
    }

    & .value {
      font-weight: 700;
      font-size: 14px;
    }
  }

  & .close-button {
    margin: 10px 15px 0;
    padding: 0 0 10px;

    & .button { background-color: #333; font-weight: 700; }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/App/FlightInformationModal.vue